import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../http.service';
import { GlobalService } from '../../global.service';
import { ZoneService } from '../../zone/zone.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-zone-register',
  templateUrl: './zone-register.component.html',
  styleUrls: ['./zone-register.component.scss']
})
export class ZoneRegisterComponent {
  zone_register_form: FormGroup;
  action: 'register' | 'update' = null;

  constructor(private formBuilder: FormBuilder, private http: HttpService,
              private global: GlobalService, private zoneService: ZoneService, private activatedRoute: ActivatedRoute) {
    this.zone_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])]
    });

    if (this.zoneService.get_zone_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.zoneService.get_zone_data);
    }
    console.log(this.action);

    console.log('zone register constructor');
    this.zoneService.zoneUpdate.subscribe((zone) => {
      console.log(zone);
      console.log(zone);
      if (zone === null) {
        this.action = 'register';
        this.zone_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(zone);
      }
    });
    console.log(this.activatedRoute.snapshot.paramMap.get('zone_id'));
  }

  registerZone() {
    this.http.registerZone(this.zone_register_form.value).subscribe((data) => {
      console.log(data);
      this.global.showSnakeBar(data['message']);
      this.zoneService.downloadZone.emit(true);
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(zone) {
    this.zone_register_form.controls['id'].setValue(zone['id']);
    this.zone_register_form.controls['name'].setValue(zone['name']);
  }

}

